import React from "react";
import { MapPin } from "lucide-react";

const CITIES = [
  "Paris",
  "Nanterre",
  "Boulogne-Billancourt",
  "Versailles",
  "Créteil",
  "Saint-Denis",
  "Bobigny",
  "Évry",
  "Cergy",
  "Melun",
  "Meaux",
  "Mantes-la-Jolie",
];

export default function Zone() {
  return (
    <section
      id="zone"
      data-testid="zone-section"
      className="relative py-24 md:py-32 bg-[#003366] text-white overflow-hidden"
    >
      <div className="absolute inset-0 diag-lines opacity-20" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <span className="inline-block w-10 h-px bg-[#FF5A1F]" />
            <span className="label-kicker text-[#FF5A1F]">
              Zone d'intervention
            </span>
          </div>
          <h2
            data-testid="zone-title"
            className="font-display font-extrabold text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1]"
          >
            Toute l'Île-de-France,
            <br />
            <span className="text-[#FF5A1F]">et ses alentours.</span>
          </h2>
          <p className="mt-6 text-slate-200/90 max-w-lg leading-relaxed">
            Paris, les Hauts-de-Seine, le Val-de-Marne, la Seine-Saint-Denis, le
            Val-d'Oise, les Yvelines, l'Essonne et la Seine-et-Marne. Une équipe
            réactive, proche de vos chantiers.
          </p>
          <a
            href="#contact"
            data-testid="zone-cta"
            className="mt-8 inline-flex items-center gap-2 bg-[#FF5A1F] hover:bg-[#E04812] text-white font-semibold px-6 py-3 text-sm transition-all hover:-translate-y-0.5"
          >
            Vérifier la disponibilité sur mon chantier
          </a>
        </div>

        <div className="lg:col-span-7">
          <div className="grid grid-cols-2 md:grid-cols-3 border-l border-t border-white/15">
            {CITIES.map((c) => (
              <div
                key={c}
                data-testid={`zone-city-${c.toLowerCase()}`}
                className="flex items-center gap-3 border-r border-b border-white/15 px-5 py-5 hover:bg-white/5 transition-colors"
              >
                <MapPin className="w-4 h-4 text-[#FF5A1F]" />
                <span className="font-display font-semibold tracking-tight">
                  {c}
                </span>
              </div>
            ))}
          </div>
          <p className="mt-4 text-xs uppercase tracking-[0.22em] text-slate-300/80">
            + toutes communes d'Île-de-France — nous consulter
          </p>
        </div>
      </div>
    </section>
  );
}
